import template from './swag-cms-extensions-form-editor-settings-field-type-select.html.twig';

const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

export default {
    template,
    data() {
        return {
            mode: null,
        };
    },
    computed: {
        ...mapPropertyErrors('field', [
            'config.options',
        ]),

        options: {
            set(newOptions) {
                this.setOptions(newOptions);
            },

            get() {
                return this.field?.translated?.config?.options ?? this.field?.config?.options;
            },
        },

        entity: {
            set(newEntity) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                    this.field.id,
                    'entity',
                    newEntity,
                );
            },

            get() {
                return this.field?.translated?.config?.entity ?? this.field?.config?.entity;
            },
        },

        placeholder: {
            set(newPlaceholder) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'placeholder',
                    newPlaceholder,
                );
            },

            get() {
                return this.field.placeholder;
            },
        },

        modes() {
            return [
                {
                    value: 'entity',
                    label: this.$tc(
                        'swag-cms-extensions.sw-cms.components.form-editor.settings-field.modeOptionEntity',
                    ),
                },
                {
                    value: 'custom',
                    label: this.$tc(
                        'swag-cms-extensions.sw-cms.components.form-editor.settings-field.modeOptionCustom',
                    ),
                },
            ];
        },

        availableEntities() {
            return [
                {
                    value: 'country',
                    label: this.$tc('global.entities.country'),
                },
                {
                    value: 'salutation',
                    label: this.$tc('global.entities.salutation'),
                },
            ];
        },
    },

    watch: {
        field() {
            if (!this.field) {
                return;
            }

            this.mode = this.entity ? 'entity' : 'custom';
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.setOptions(this.options);
            this.mode = this.entity ? 'entity' : 'custom';
        },

        setOptions(newOptions) {
            newOptions = Array.from(new Set(newOptions));

            Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                this.field.id,
                'options',
                newOptions.length > 0 ? newOptions : undefined,
            );
        },

        onModeChange() {
            if (this.mode === 'entity') {
                this.options = undefined;
            } else {
                this.entity = undefined;
            }

            Shopware.Store.get('swCmsDetailCurrentCustomForm').changeFieldSelectConfig(
                this.field.id,
                this.mode,
            );
            this.setOptions(this.options);
        },

        onCustomOptionsChange() {
            if (!this.fieldConfigOptionsError) {
                return;
            }

            Shopware.Store.get('error').removeApiError(this.fieldConfigOptionsError.selfLink);
        },
    },
}
